
export class GetAppointmentsRequestDto {
  offsetDays: number;
  days: number;
}
